import type { ElementType } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Construction } from 'lucide-react';

interface Props {
  titleKey: string;
  icon?: ElementType;
}

export function ComingSoonPage({ titleKey, icon: Icon = Construction }: Props) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center justify-center text-center py-24 px-6">
      <div className="w-20 h-20 rounded-full bg-brand-50 text-brand-700 flex items-center justify-center mb-6">
        <Icon className="w-10 h-10" />
      </div>
      <h1 className="text-2xl font-bold text-slate-900 mb-1">{t(titleKey)}</h1>
      <p className="text-base font-medium text-slate-700 mb-2">{t('comingSoon.title')}</p>
      <p className="text-sm text-slate-500 max-w-md mb-8">{t('comingSoon.description')}</p>
      <Link
        to="/"
        className="inline-flex items-center gap-2 rounded-md bg-brand-700 px-4 py-2 text-sm font-medium text-white hover:bg-brand-500 transition-colors"
      >
        ← {t('comingSoon.backHome')}
      </Link>
    </div>
  );
}
